module.exports = __webpack_public_path__ + "img/22.5de62633.jpg";